<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="1000px">
        <PublicContent ref="PublicContent" v-bind="$attrs" />
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_apply') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { roleNew } from '@/api/modules/role.js'

import PublicContent from './rolePublic.vue'
export default {
    props: ['title', 'isShow'],
    computed: {
        isShowDialog: {
            get: function () {
                return this.isShow
            },
            set: function (val) {
                this.$emit('update:isShow', val);//可以优化成model  或者minx
            }
        }

    },
    components: {
        PublicContent
    },
    methods: {
        clearValidate() {
            this.$nextTick(() => {

                this.$refs['PublicContent'].resetInitData();
            })
        },
        async handleSave() {
            let falg = await this.$refs['PublicContent'].justify();
            if (!falg) return
            let dioForm = this.$refs['PublicContent'].dioForm
            if (dioForm.type === -1) {
                dioForm.customerIds = this.$refs['PublicContent'].customerIdArray.map(item => item.customerIds)

            } else {
                dioForm.customerIds = ''
            }
            for (let key in dioForm) {
                if (dioForm[key] === '') {
                    delete dioForm[key]
                }
            }
            roleNew(dioForm).then(({ result, state }) => {
                if (result === 200) {
                    this.isShowDialog = false;
                    this.$message.success(this.$t("user.user_new_code_200"))
                    this.$parent.getListFn();
                } else if (result === 405) {
                    this.$message.error(this.$t("user.role_edit_code_405"))
                } else if (result === 406) {
                    this.$message.error(this.$t("user.role_edit_code_406"))
                } else if (result === 407) {
                    this.$message.error(this.$t("user.role_edit_code_407"))
                } else if (result === 408) {
                    this.$message.error(this.$t("user.role_edit_code_408"))
                } else if (result === 409) {
                    this.$message.error(this.$t("user.role_edit_code_409"))
                } else if (result === 410) {
                    this.$message.error(this.$t("user.role_edit_code_410"))
                } else if (result === 411) {
                    this.$message.error(this.$t("user.role_edit_code_411"))
                } else if (result === 412) {
                    this.$message.error(this.$t("user.role_edit_code_412"))
                } else if (result === 413) {
                    this.$message.error(this.$t("user.role_edit_code_413"))
                } else if (result === 415) {
                    this.$message.error(this.$t("user.role_edit_code_415"))
                } else {
                    this.$message.error(this.$t("user.role_edit_code_500"))
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>